/**
 * The AI route table (design C12 §5.5).
 *
 * `web/src/router/index.ts` is P11's file, so the table is declared here and
 * imported there — the shape every module in this app uses.
 *
 * There is deliberately **no route for the Assistant**: it lives in the right
 * rail, beside whatever the user is looking at, because an assistant you have
 * to navigate away to reach is one that has lost the context it was going to
 * answer about (CLAUDE.md §11).
 *
 * Every route is gated on a permission that does not exist when AI is disabled
 * at the instance — `ai.Routes()` returns nil, nobody holds an `ai.*` code, and
 * the nav hides the group. §10.1's "hide, not error", by the ordinary
 * mechanism rather than a flag.
 */

import type { RouteRecordRaw } from 'vue-router'

import { AI_PERMISSIONS } from '@/modules/ai/permissions'

export const AI_ROUTES: RouteRecordRaw[] = [
  {
    path: '/ai/briefings',
    name: 'ai-briefings',
    component: () => import('@/modules/ai/BriefingsView.vue'),
    meta: { titleKey: 'ai.routeTitles.briefings', permission: AI_PERMISSIONS.agentRead },
  },
  {
    path: '/ai/briefings/:id(\\d+)',
    name: 'ai-briefing',
    component: () => import('@/modules/ai/BriefingDetailView.vue'),
    meta: { titleKey: 'ai.routeTitles.briefing', permission: AI_PERMISSIONS.agentRead },
  },
  {
    path: '/ai/autonomy',
    name: 'ai-autonomy',
    component: () => import('@/modules/ai/AutonomyView.vue'),
    meta: { titleKey: 'ai.routeTitles.autonomy', permission: AI_PERMISSIONS.capabilityRead },
  },
  {
    path: '/ai/recommendations',
    name: 'ai-recommendations',
    component: () => import('@/modules/ai/RecommendationLedgerView.vue'),
    meta: { titleKey: 'ai.routeTitles.ledger', permission: AI_PERMISSIONS.recommendationRead },
  },
  {
    path: '/ai/config-anomalies',
    name: 'ai-config-anomalies',
    component: () => import('@/modules/ai/ConfigAnomaliesView.vue'),
    meta: { titleKey: 'ai.routeTitles.anomalies', permission: AI_PERMISSIONS.anomalyRead },
  },
]
